<script>
    import { OnClickBaseEquipment, OnClickFreeEquipment } from '../../../script/handle/play'

    export let Position, Equipment

</script>

{#if Equipment != undefined}
    <div class='equipment'>
        {#if Equipment.length > 0}
            추천 장비 :
            <ul>
                {#each Equipment as item, i}
                    <li>
                        {#if item.num > 0}
                            <img
                                src="../img/equipment/equip/{item.num}.png"
                                alt="equip_{item.num}"
                            >
                            <div class="bottom">
                                {#if item.base[0] > 0}
                                    <div
                                        class="base"
                                        on:click={() => OnClickBaseEquipment(Position, i, 0)}
                                    >
                                        <img
                                            src="../img/equipment/base/{item.base[0]}.png"
                                            alt="equip_{item.num}"
                                        >
                                    </div>
                                {/if}

                                {#if item.base[1] > 0}
                                    <div
                                        class="base"
                                        on:click={() => OnClickBaseEquipment(Position, i, 1)}
                                    >
                                        <img
                                            src="../img/equipment/base/{item.base[1]}.png"
                                            alt="equip_{item.num}"
                                        >
                                    </div>
                                {/if}
                            </div>
                        {:else}
                            <button on:click={() => OnClickFreeEquipment(Position, i)}>자유 선택</button>
                        {/if}
                    </li>
                {/each}
            </ul>
        {/if}
    </div>
{/if}

<style lang="scss">
    .temperament {
        width: calc(100% - 10px);
        height: fit-content;
        padding: 5px;
        font-size: 16px;
        font-family: aggro;

        border: 2px solid $cl1;
        border-radius: $br1;
        cursor: pointer;

        &:hover { border: 2px solid $cl3; }
    }

    .equipment {
        width: calc(100% - 10px);
        height: fit-content;
        padding: 5px;
        font-size: 16px;
        font-family: aggro;

        ul {
            width: 100%;
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: space-between;

            li {
                width: 33%;
                list-style:none;

                img { width: 100%; }

                .bottom {
                    width: calc(100% - 10px);
                    height: fit-content;
                    padding: 5px;
                    display: flex;
                    justify-content: space-between;

                    .base {
                        width: calc(50% - 20px);
                        height: fit-content;
                        padding: 10px;
                        border: 2px solid $cl1;
                        border-radius: $br1;
                        cursor: pointer;

                        &:hover { border: 2px solid $cl3; }

                        img { width: 100%; }
                    }
                }

                button {
                    background: none;
                    width: 100%;
                    height: 100%;
                    min-height: 100px;
                    border: 2px solid $cl3;
                    border-radius: $br1;
                    color: $cl2;
                    font-size: 20px;
                    font-family: aggro;

                    &:hover {
                        background: $cl3;
                    }
                }
            }
        }
    }
</style>